import {AccessLevel} from '$lib/classes/_enum/access-level';

export class AccessLevelState {

    current: AccessLevel = $derived.by(() => {
        if (this.getLoggedIn()) {
            if (this.getHasActiveProVersion() || this.getHasActiveSubscription() || this.getHasActiveMobileSubscription()) {
                return AccessLevel.ProPlan
            } else if (this.getHasActiveTrial()) {
                return AccessLevel.Trial
            } else {
                return AccessLevel.FreeTier
            }
        } else {
            return AccessLevel.Public
        }
    })

    constructor(
        private readonly getLoggedIn: () => boolean,
        private readonly getHasActiveTrial: () => boolean,
        private readonly getHasActiveProVersion: () => boolean,
        private readonly getHasActiveSubscription: () => boolean,
        private readonly getHasActiveMobileSubscription: () => boolean
    ) {
        // TODO refactor when upgraded to Svelte > 5.31 (+remove 'private readonly' modifier)
        // this.current = $derived.by(() => {
        // ...
        // });
    }
}